import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Server, Trash2, PlugZap, Loader2 } from "lucide-react";

const TYPE_LABELS = {
  postgres: "PostgreSQL", postgresql: "PostgreSQL", mysql: "MySQL", supabase: "Supabase", mongodb: "MongoDB",
  sqlserver: "SQL Server", mssql: "SQL Server", oracle: "Oracle",
  snowflake: "Snowflake", bigquery: "Google BigQuery", redshift: "Amazon Redshift",
  databricks: "Databricks SQL", synapse: "Azure Synapse", athena: "AWS Athena",
  gsheet: "Google Sheets", rest: "REST / JSON API",
};

export function ConnectionsPanel() {
  const [conns, setConns] = useState(null);
  const [testingId, setTestingId] = useState(null);
  const load = () => api.get("/connections").then(({ data }) => setConns(data)).catch(() => setConns([]));
  useEffect(() => { load(); }, []);

  const test = async (c) => {
    setTestingId(c.id);
    try {
      const { data } = await api.post(`/connections/${c.id}/tables`);
      toast.success(`“${c.name}” is healthy — ${(data.tables || []).length} tables reachable`);
    } catch (e) { toast.error(e?.response?.data?.detail || "Connection test failed"); }
    finally { setTestingId(null); }
  };
  const del = async (c) => {
    try { await api.delete(`/connections/${c.id}`); toast.success("Connection deleted"); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Delete failed"); }
  };

  if (!conns || conns.length === 0) return null;
  return (
    <div data-testid="connections-panel" className="mt-8">
      <h2 className="font-display text-base text-[color:var(--ink)] flex items-center gap-2 mb-3"><Server className="w-4 h-4 text-[color:var(--brand-ocean)]" />Saved connections</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {conns.map((c) => (
          <div key={c.id} data-testid="connection-card" className="glass-card p-4 flex items-center gap-3">
            <div className="w-9 h-9 rounded-lg hero-gradient flex items-center justify-center border border-[color:var(--glass-border)] shrink-0"><Server className="w-4 h-4 text-[color:var(--brand-ocean)]" /></div>
            <div className="min-w-0 flex-1">
              <div className="text-sm font-medium text-[color:var(--ink)] truncate">{c.name}</div>
              <div className="text-[11px] text-[color:var(--ink-3)]">{TYPE_LABELS[c.db_type] || c.db_type}{c.created_at ? ` · added ${new Date(c.created_at).toLocaleDateString()}` : ""}</div>
            </div>
            <Button data-testid="connection-test-btn" size="sm" variant="ghost" onClick={() => test(c)} disabled={testingId === c.id} className="text-[color:var(--brand-ocean)]" title="Test connection">
              {testingId === c.id ? <Loader2 className="w-4 h-4 animate-spin" /> : <PlugZap className="w-4 h-4" />}
            </Button>
            <Button data-testid="connection-delete-btn" size="sm" variant="ghost" onClick={() => del(c)} className="text-[color:var(--danger)]" title="Delete connection"><Trash2 className="w-4 h-4" /></Button>
          </div>
        ))}
      </div>
    </div>
  );
}
